import React from "react";
import DisplayValue from "../../../../display-value/DisplayValue";
import {
    DetailRow,
    DetailSection,
    TicketProperties, sectionRegistry,
} from "./base";

export default function GeneralSection({ ticket, isMinimized, onToggleExpand }: TicketProperties) {
    ticket.useChatDetails();
    return ticket.ticket.customContextValues?.isNotEmpty ? (
        <DetailSection title="Context" isMinimized={isMinimized} onToggleExpand={onToggleExpand}>
            {ticket.ticket.customContextValues.map(contextLine => (
                <DetailRow title={contextLine.label} key={contextLine.id} description={contextLine.description}>
                    <DisplayValue
                        text={contextLine.displayText ?? contextLine.value.string as string}
                        type={contextLine.displayType}
                        value={contextLine.value.string as string}
                    />
                </DetailRow>
            ))}

        </DetailSection>
    ) : undefined;
}

sectionRegistry.register({
    sectionId: "urn:fq:portal-chat-section:custom-context",
    label: "Custom Context",
    component: GeneralSection,
});
